/**
 * 私人地址列表
 */
export function baseDataPrivateAddressList(){
  return Array(10).fill({}).map((res,index)=>{
    return {
      label:index,
      value:index,
      namec:index,
      id:index,
      isPrivateAddress:true,
      quoteStatus:undefined,
    }
  })
}



// WEBPACK FOOTER //
// ./src/commonQuery/reqeustBaseData.js